export const leadMagnetsData = [
  {
    path: "email-flows-you-need",
    title: "Top Email Flows for 2026",
    description:
      "Download my private list of email flows that you need to install in your business",
    creatorName: "Nathan Lee",
    imageSrc: "/img/jailbird.jpg",
    magnetId: "email-flows-lead",
  },
  {
    path: "ecom-offers-2026",
    title: "Ecom Offer Frameworks",
    description:
      "Download my PDF copy of the frameworks we use to build evergreen promotional offers for our clients for FREE",
    creatorName: "Nathan Lee",
    imageSrc: "/img/offers-thumb.png",
    magnetId: "offer-creation",
  },
  {
    path: "drop-day-blueprint",
    title: "Drop Day / Seasonal Sales Blueprint",
    description:
      "Download my PDF copy of the blueprint we use to build drop day funnels for our clients for FREE",
    creatorName: "Nathan Lee",
    imageSrc: "/img/drop-day-thumb.png",
    magnetId: "drop-day",
  },
  {
    path: "true-classic-blueprint",
    title: "True Classic's $250M Blueprint",
    description: "Download my breakdown of True Classic's funnel for FREE",
    creatorName: "Nathan Lee",
    imageSrc: "/img/true-classic-thumb.png",
    magnetId: "true-classic",
  },
  {
    path: "meg-squats-breakdown",
    title: "@megsquats $3M Breakdown",
    description:
      "Download my full PDF breakdown of @megsquats's funnel for FREE",
    creatorName: "Nathan Lee",
    imageSrc: "/img/meg-squats-thumb.png",
    magnetId: "meg-squats",
  },
  {
    path: "small-budget-campaign",
    title: "H² Method for Small & Tiny Meta Ads Budgets",
    description:
      "Download my full PDF breakdown of how to scale a Meta Campaign on a small or tiny budget for FREE",
    creatorName: "Nathan Lee",
    imageSrc: "/img/small-budget-campaign.png",
    magnetId: "small-budget-campaign",
  },
  {
    path: "klaviyo-sop",
    title: "Klaviyo SOP: Setting up the Core 6 Flows to Scale Your Brand",
    description:
      "Download literally the Hoshino Media Team's SOP on how to setup Klaviyo for FREE",
    creatorName: "Nathan Lee",
    imageSrc: "/img/klaviyo-sop-thumb.png",
    magnetId: "klaviyo-sop",
  },
  {
    path: "brand-pos-matrix",
    title: "Brand Positioning Matrix: Developing your brand's voice",
    description:
      "Being consistent makes for a great brand that people cling to.",
    creatorName: "Nathan Lee",
    imageSrc: "/img/brand-pos-thumb.png",
    magnetId: "brand-pos-matrix",
  },
];
